

import React, { useState } from 'react';
import styles from './Feature.css';
import Img1 from '../../images/illustration-features-tab-1.svg';
import Img2 from '../../images/illustration-features-tab-2.svg';
import Img3 from '../../images/illustration-features-tab-3.svg';

const imageList = [
  {
    image: Img1,
    heading: "Bookmark in one click",
    text: "Organize your bookmarks however you like. Our simple drag-and-drop interface gives you complete control over how you manage your favourite sites.",
    btntext: "More Info"
  },
  {
    image: Img2,
    heading: "Intelligent search",
    text: "Our powerful search feature will help you find saved sites in no time at all. No need to trawl through all of your bookmarks.",
    btntext: "More Info"
  },
  {
    image: Img3,
    heading: "Share your bookmarks",
    text: "Easily share your bookmarks and collections with others. Create a shareable link that you can send at the click of a button.",
    btntext: "More Info"
  }
];

function Feature() {
  const [activeTab, setActiveTab] = useState(0); 

  const handleLinkClick = (index, event) => {
    event.preventDefault(); // Prevent default link behavior
    setActiveTab(index);
  };

  return (
    <section id='features' className='feature'>
      <div className="container feature-container">
        <h3>Feature</h3>
        <p className='feature-intro-text'>Our aim is to make it quick and easy for you to access your favourite websites. Your bookmarks sync between your devices so you can access them on the go.</p>

        <div className="feature-page-links">
          <div className={`link simple-bookmarking ${activeTab === 0 ? 'active' : ''}`}>
            <a href="#" onClick={(event) => handleLinkClick(0, event)}>Simple Bookmarking</a>
          </div>
          <div className={`link speed-search ${activeTab === 1 ? 'active' : ''}`}>
            <a href="#" onClick={(event) => handleLinkClick(1, event)}>Speed Searching</a>
          </div>
          <div className={`link eazy-sharing ${activeTab === 2 ? 'active' : ''}`}>
            <a href="#" onClick={(event) => handleLinkClick(2, event)}>Eazy Sharing</a>
          </div>
        </div>

        {activeTab !== null && (
          <div className="feature-content">
            <img src={imageList[activeTab].image} alt={imageList[activeTab].heading} />
            <div className="feature-content-text-container">
              <h4 className='feature-heading'>{imageList[activeTab].heading}</h4>
              <p className='feature-text'>{imageList[activeTab].text}</p>
              <a className='feature-btn-link' href="#">{imageList[activeTab].btntext}</a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Feature;
